// extracted by mini-css-extract-plugin
module.exports = {"root":"Detail_root__2yJXF","name":"Detail_name__1crGt","line":"Detail_line__2Tdok","value":"Detail_value__2pCbQ"};